'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveCarouselSm = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nukaCarousel = require('nuka-carousel');

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponsiveCarouselSm = exports.ResponsiveCarouselSm = function ResponsiveCarouselSm(_ref) {
  var children = _ref.children,
      extraClass = _ref.extraClass,
      handleSlide = _ref.handleSlide,
      loading = _ref.loading;

  if (loading || !children || !children.length) {
    return false;
  }

  return _react2.default.createElement(
    _nukaCarousel2.default,
    {
      afterSlide: handleSlide,
      className: extraClass,
      cellAlign: 'left',
      cellSpacing: children.length > 1 ? 30 : 0 // workaround for https://github.com/FormidableLabs/nuka-carousel/issues/234
      , decorators: [{
        component: function component() {
          return null;
        }
      }],
      edgeEasing: 'easeOut',
      speed: 150,
      slidesToShow: 1,
      slidesToScroll: 1,
      slideWidth: '190px',
      width: '100%'
    },
    children
  );
};

ResponsiveCarouselSm.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.element),
  extraClass: _propTypes2.default.string,
  handleSlide: _propTypes2.default.func,
  loading: _propTypes2.default.bool
};